import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';

import { mapWidth } from '../helpers/map-width';
import type { TLayoutDesktop } from '../models';

export const Layout: FC<TLayoutDesktop> = ({
    children,
    className,
    classNames: { layout, layoutContent } = {},
    contentWidth,
    dataTestId = 'layout',
    hasPadding = true,
    scroll,
    styles,
    ...props
}) => {
    return (
        <div
            className={cn(
                {
                    [styles.layout]: !scroll && hasPadding,
                },
                layout,
                className
            )}
            data-test-id={dataTestId}
            {...props}
        >
            <div
                className={cn(
                    {
                        [styles.layoutContent]: !scroll,
                    },
                    layoutContent
                )}
                style={contentWidth ? { maxWidth: mapWidth(contentWidth) } : undefined}
            >
                {children}
            </div>
        </div>
    );
};
